module.exports = __webpack_public_path__ + "media/images/push_notification_guide-be6c8b80a67d3d8f0d653757d38f09ac.png";